import React, {Component} from 'react';
import './ImageSlider.css';
import ImageSliderQuotation from './ImageSliderQuotation/ImageSliderQuotation';
import {IS_IN_MOBILE_MODE, PAGE_OPEN_TYPE} from "../../../../configuration";
import LeftArrow from "../../../../assets/img/imageSlider/left_arrow.png";
import RightArrow from "../../../../assets/img/imageSlider/right_arrow.png";
import Banner1 from "../../../../assets/img/imageSlider/B6.png";
import Banner2 from "../../../../assets/img/imageSlider/B8.png";
import Banner3 from "../../../../assets/img/imageSlider/B7.png";
import Banner4 from "../../../../assets/img/imageSlider/Banner_12_1.png";
import Banner5 from "../../../../assets/img/imageSlider/Banner_13.png";
import Banner6 from "../../../../assets/img/imageSlider/B9.png";

let slideIndex = 1;

class ImageSlider extends Component {

    constructor(props) {
        super(props);
        this.showSlides = this.showSlides.bind(this);
        this.plusSlides = this.plusSlides.bind(this);

        this.state = {
            inputStyle: "",
            status: true
        }
    }

    componentDidMount() {

        let slideIndex = 1;
        this.showSlides(slideIndex);

    }


    showSlides = (n) => {

        let i;
        let slides = document.getElementsByClassName("mySlides");

        if (n > slides.length) {
            slideIndex = 1
        }
        if (n < 1) {
            slideIndex = slides.length
        }
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        slides[slideIndex - 1].style.display = "block";

    };


    plusSlides = (n) => {
        this.showSlides(slideIndex += n);
    };

    render() {
        return (
            <div className="image-slideshow" onAnimationIteration={() => this.plusSlides(1)}>
                <div className='slider' >

                    {/*<div className="mySlides img-fade  slide ">*/}
                    {/*    /!*<span className="image imageSlider-image image" id="imageSlider">*!/*/}
                    {/*    /!*    <img src={Banner1} alt ="Banner" className="slider-images-home"/>*!/*/}
                    {/*    /!*</span>*!/*/}
                    {/*    <span className="image imageSlider-image image" id="imageSlider">*/}
                    {/*        <a href="https://kitcutlabo.blog/promotion001"*/}
                    {/*           target={PAGE_OPEN_TYPE}*/}
                    {/*        >*/}
                    {/*        <img src={Banner6} alt ="Banner" className="slider-images-home"/>*/}
                    {/*        </a>*/}
                    {/*    </span>*/}
                    {/*</div>*/}

                    {/*<div className="mySlides img-fade  slide">*/}
                    {/*    <span className="image imageSlider-image image ">*/}
                    {/*        <img src={Banner2} alt ="Banner" className="slider-images-home"/>*/}

                    {/*    </span>*/}
                    {/*</div>*/}

                    <div className="mySlides img-fade  slide">
                        <span className="image imageSlider-image image">
                          <img src={Banner3} alt ="Banner" className="slider-images-home"/>
                        </span>
                    </div>

                    <div className="mySlides img-fade  slide">
                        <span className="image imageSlider-image image">
                          <img src={Banner4} alt ="Banner" className="slider-images-home"/>
                        </span>
                    </div>

                    <div className="mySlides img-fade  slide">
                        <span className="image imageSlider-image image">
                          <img src={Banner5} alt ="Banner" className="slider-images-home"/>

                        </span>
                    </div>

                    <a className="prev" onClick={() => this.plusSlides(-1)}><img src={LeftArrow} className="left-arrow-resp" alt="<"/></a>
                    <a className="next" onClick={() => this.plusSlides(1)}><img src={RightArrow} className="right-arrow-resp" alt=">"/></a>

                    <br/>

                    <div>
                        <div className="form-container no-padding slider-quotation-responsive">
                            <ImageSliderQuotation/>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/ImageSlider/ImageSlider.js